<template>
  <div class="reimbursement-search reimbursement-approval">
    <div class="top-container">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="100px"
      >
        <div class="row">
          <el-form-item label="单据名称：" prop="billName">
            <el-input
              class="gray white w200"
              placeholder="请输入"
              v-model="ruleForm.billName"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="单据号：" prop="billCode">
            <el-input
              class="gray white w240"
              placeholder="请输入"
              v-model="ruleForm.billCode"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="经办人：" prop="agent">
            <el-input
              class="gray white w200"
              placeholder="请输入"
              v-model="ruleForm.agent"
              clearable
            ></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="部门：" prop="deptName">
            <el-input
              class="gray white w200"
              placeholder="请输入"
              v-model="ruleForm.deptName"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="发起时间：" prop="date">
            <el-date-picker
              class="w240 gray white"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              v-model="ruleForm.date"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="开支内容：" prop="content">
            <el-input class="gray white w200" placeholder="请输入" v-model="ruleForm.content" clearable></el-input>
          </el-form-item>

          <el-form-item class="btn">
            <el-button class="btn-gray" @click="resetForm('ruleForm')"
              >重置</el-button
            >
            <el-button class="btn-blue" type="primary" @click="search"
              >搜索</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="container">
      <div class="table">
        <el-table :data="tableData">
          <el-table-column prop="billCode" label="单据号" width="160">
          </el-table-column>
          <el-table-column prop="formName" label="单据名称" min-width="120" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="agent" label="经办人" show-overflow-tooltip>
            <template slot-scope="scope">
              <div>
                {{scope.row.agent}}
                <el-tooltip v-if="scope.row.isReplaceReimburse" class="item" effect="dark" :content="scope.row.generationContent" placement="top">
                  <span class="generation">代</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.lable"
            :min-width="item.width"
            show-overflow-tooltip
          />
          <el-table-column prop="status" label="状态" min-width="160">
            <template slot-scope="scope">
              <div class="table-status">
                <span
                  class="spot"
                  :class="
                    scope.row.status == 3
                      ? 'red'
                      : scope.row.status == 2
                      ? 'green'
                      : scope.row.status == 5
                      ? 'spot-gray'
                      : 'blue'
                  "
                ></span>
                <span>{{ scope.row.statusVal }}</span>
                <span v-if="scope.row.needSupplementData && scope.row.isFinancialReviewer" class="supplement-data">待补齐资料</span>
                <span v-if="scope.row.hasLastSupplementData == 1 && scope.row.isFinancialReviewer" class="supplement-data completed-data">已补齐资料</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" class="btn-text" @click="agree(scope.row)"
                >同意</el-button
              >
              <el-button
                type="text"
                class="btn-text-red"
                @click="reject(scope.row)"
                >拒绝</el-button
              >
              <el-dropdown v-if="scope.row.isFinancialReviewer" trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  更多<i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="!scope.row.needSupplementData"
                    :command="beforeHandleCommand(scope.row, 'supplement')"
                    class="supplement"
                    >补齐资料</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="beforeHandleCommand(scope.row, 'transfer')"
                    class="transfer"
                    >移交</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <el-button
                type="text"
                class="btn-text"
                @click="lookDetails(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-tpl-container">
          <pagination-tpl
            :total="totalNum"
            :currentPage="currentPage"
            @queryChange="onQueryChange"
          ></pagination-tpl>
        </div>
      </div>
    </div>

    <!-- 补齐资料、增加费用、移交 -->
    <finance-more
      :type="type"
      :title="title"
      :deptId="deptId"
      :teamId="teamId"
      :dialogVisible="dialogVisible"
      :financeMoreData="financeMoreData"
      @handleClose="handleClose"
    ></finance-more>

    <!-- 签名 -->
    <sign
      :dialogSignVisible="dialogSignVisible"
      :signApprovalData="signApprovalData"
      @signAgree="signAgree"
      @handleSignClose="handleSignClose"
    ></sign>

    <!-- 拒绝 -->
    <el-dialog
      title="拒绝"
      width="540px"
      class="approval-reject"
      :visible.sync="dialogApprovalBillRejectVisible"
    >
      <el-form :model="approvalBillRejectForm" ref="approvalBillRejectForm">
        <el-form-item label="备注" prop="remarks">
          <el-input
            type="textarea"
            placeholder="最多输入50个字"
            v-model="approvalBillRejectForm.remark"
            maxlength="50"
            show-word-limit
            resize="none"
            rows="3"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleApprovalBillRejectClose">取 消</el-button>
        <el-button class="btn-red" @click="rejectComfirm">拒绝</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import { config } from "@/common/js/config.js";
import PaginationTpl from "@/components/PaginationTpl.vue";
import {
  formatTimeToDate,
  handleAmount,
} from "@/common/js/utils.js";
import { statusMixins } from "@/common/mixins/status/status.js";
import Sign from "@/components/sign";
import FinanceMore from "@/components/finance-more";
import FinanceApproval from "@/models/finance-approval.js";
export default {
  inject: ['reload'],
  mixins: [statusMixins],
  components: {
    PaginationTpl,
    Sign,
    FinanceMore
  },

  data() {
    return {
      ruleForm: {
        billName: "",
        billCode: "",
        agent: "",
        date: "",
        deptName: "",
        content: "",
      },
      tableData: [],
      tableTitleList: [
        { prop: "balance", lable: "金额", width: "" },
        { prop: "department", lable: "部门", width: "" },
        { prop: "createTime", lable: "发起时间", width: "100" },
      ],
      totalNum: 0,
      currentPage: 1,
      title: "补齐资料",
      type: 1,
      dialogVisible: false,
      dialogSignVisible: false,
      signApprovalData: null,
      financeMoreData: null,
      deptId: '',
      teamId: '',
      timerId: null,
      // 记录滚动条滚动位置
      scroll: 0,
      dialogApprovalBillRejectVisible: false,
      approvalBillRejectForm: {
        remark: '',
        type: null,
        orderId: null,
        balance: 0
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    let arr = ['finishApproval', 'finishApprovalDetails']
    if (arr.indexOf(to.name) !== -1) this.reload()
    this.scroll = document.querySelector('.approval-scroll').scrollTop
    next()
  },
  /* 缓存组件激活时调用 */
  activated() {
    config();
    if (document.querySelector('.approval-scroll')) document.querySelector('.approval-scroll').scrollTop = this.scroll
    this.initFinanceApprovalList()
  },

  beforeCreate() {
    this.timerId = setTimeout(() => {
      this.$bus.emit('isShowTopMenu', true)
    })
  },
  created() {
    config();
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
  },

  methods: {
    initFinanceApprovalList() {
      let data = {};
      data.formName = this.ruleForm.billName;
      data.code = this.ruleForm.billCode;
      data.username = this.ruleForm.agent;
      data.deptName = this.ruleForm.deptName;
      data.startDate = this.ruleForm.date ? this.ruleForm.date[0] : "";
      data.endDate = this.ruleForm.date ? this.ruleForm.date[1] : "";
      data.currentPage = this.currentPage;
      data.content = this.ruleForm.content;
      FinanceApproval.financeApprovalList(data).then((res) => {
        if (res.success) {
          let arr = [];
          this.totalNum = res.result.totalNum;
          res.result.items.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.billCode = i.code;
            obj.deptId = i.deptId;
            obj.teamId = i.teamId;
            obj.type = i.orderType;
            obj.formName = i.formName;
            obj.billType = this.BILL_TYPE[i.orderType];
            obj.agent = i.username;
            obj.balance = handleAmount(i.amount, 2);
            obj.department = i.deptName;
            obj.createTime = formatTimeToDate(i.createTime);
            obj.status = i.status;
            obj.statusVal = this.BILL_SEARCH_REIMBURSEMENT_STATUS[i.status];
            obj.needSupplementData = i.needSupplementData
            obj.hasLastSupplementData = i.hasLastSupplementData
            obj.isFinancialReviewer = i.isFinancialReviewer
            obj.isReplaceReimburse = i.isReplaceReimburse
            obj.createUsername = i.createUsername
            obj.generationContent = `“${i.createUsername}”代“${i.username}”发起的报销`
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initFinanceApprovalList();
    },

    /* 搜索 */
    search() {
      this.currentPage = 1;
      this.initFinanceApprovalList();
    },

    /* 重置 */
    resetForm(formName) {
      this.departmentId = 0;
      // this.reimbursementTypeId = 0;
      this.$nextTick(() => {
        this.$bus.emit("getFepartmentId", 0);
      });
      this.$refs[formName].resetFields();
    },

    agree(row) {
      let type = row.type
      let orderId = row.id
      let agree = 1
      let bankAmount = handleAmount(row.balance,1)
      let data = {
        type,
        orderId,
        agree,
        bankAmount
      }
      this.signApprovalData = data
      this.dialogSignVisible = true;
    },

    reject(row) {
      this.approvalBillRejectForm.type = row.type
      this.approvalBillRejectForm.orderId = row.id
      this.approvalBillRejectForm.balance = row.balance
      this.dialogApprovalBillRejectVisible = true
    },

    signAgree() {
      this.initFinanceApprovalList()
    },

    lookDetails(row) {
      this.$router.push({
        path: '/finance/reimbursementIndex/approvalIndex/approvalDetails',
        query: {
          id: row.id,
          type: row.type,
          billCode: row.billCode,
          deptId: row.deptId,
          teamId: row.teamId
        }
      })
    },

    /*
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value, command) {
      return {
        value: value,
        command: command,
      };
    },

    handleCommand(command) {
      switch (command.command) {
        case "supplement":
          this.type = 1;
          this.title = "补齐资料";
          let orderId = command.value.id
          let type = command.value.type
          let data = {
            orderId,
            type
          }
          this.financeMoreData = data
          this.dialogVisible = true;
          break;
        case "transfer":
          this.type = 2;
          this.title = "移交";
          this.deptId = command.value.deptId
          this.teamId = command.value.teamId
          let id = command.value.id
          let orderType = command.value.type
          let dataObj = {
            id,
            orderType
          }
          this.financeMoreData = dataObj
          this.dialogVisible = true;
          break;
      }
    },

    handleClose() {
      this.type = 1;
      this.dialogVisible = false;
    },

    handleSignClose() {
      this.dialogSignVisible = false
    },

    handleApprovalBillRejectClose() {
      this.approvalBillRejectForm.type = null
      this.approvalBillRejectForm.orderId = null
      this.approvalBillRejectForm.balance = 0
      this.approvalBillRejectForm.remark = ''
      this.dialogApprovalBillRejectVisible = false
    },

    rejectComfirm() {
      let type = this.approvalBillRejectForm.type
      let orderId = this.approvalBillRejectForm.orderId
      let agree = 0
      let bankAmount = handleAmount(this.approvalBillRejectForm.balance,1)
      let sign = ''
      let remark = this.approvalBillRejectForm.remark
      let data = {
        type,
        orderId,
        agree,
        bankAmount,
        sign,
        remark
      }
      FinanceApproval.financeApproval(data).then(res => {
        if (res.success) {
          this.handleApprovalBillRejectClose()
          this.initFinanceApprovalList()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    }
  },
};
</script>

<style lang='scss'>
.reimbursement-approval {
  padding: 20px 20px 0px 20px;
  box-sizing: border-box;
  .supplement-data {
    width: 70px;
    height: 20px;
    line-height: 20px;
    border: 1px solid $bg-Crimson;
    border-radius: 2px;
    font-size: $fs-small-m;
    color: $color-Crimson;
    text-align: center;
    margin-left: 10px;
  }
  .completed-data {
    color: $low-risk;
    border-color: $low-risk;
  }
  .el-dropdown-link {
    color: $color-DeepReddishBlue;
    cursor: pointer;
    margin: 0px 10px;
  }
  .generation {
    cursor: pointer;
    padding: 0px 4px;
    color: $color-DeepReddishBlue;
    border: 1px solid $bg-DeepReddishBlue;
  }

  .approval-reject {
    .el-dialog__header {
      border-bottom: none;
    }
    .el-dialog__body {
      .el-form {
        padding-top: 0px;
        padding-bottom: 0px;
        .el-form-item__label {
          line-height: 28px;
        }
        .el-textarea {
          .el-textarea__inner{
            height: 56px!important;
          }
          .el-input__count {
            bottom: 16px;
            height: 16px;
          }
        }
      }
    }
    .el-dialog__footer {
      border-top: none;
      justify-content: flex-end;
      .btn-red {
        background: $bg-Crimson!important;
        color: white!important;
      }
    }
  }
}
</style>
